var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 12,
    viewBox: "0 0 40 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0L20 12L1.04907e-06 -3.49691e-06L40 0Z",
    fill: "#33B1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomArrow);
export default __webpack_public_path__ + "static/media/bottom-arrow.2de4e318a3bcbef60b4116f8679d978a.svg";
export { ForwardRef as ReactComponent };